import { useState } from 'react'

import { useNotification } from '../../../../../hooks'
import { REQUEST_PROFILE_TAB_INTERNAL_TASKS_NOTIFICATION_TITLE_KEY } from '../../RequestProfileTabInternalTasks.constants'
import { useRequestProfileTabInternalTasksContext } from '../useRequestProfileTabInternalTasksContext'

export function useRequestProfileTabInternalTasksChecklistItemActions({
  checklistId,
  checklistItem,
}) {
  const { canEdit, handleDeleteChecklistItem, handleUpdateChecklistItem } =
    useRequestProfileTabInternalTasksContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const [isEditing, setEditing] = useState(false)

  const [isSubmitting, setSubmitting] = useState(false)

  const [isTogglingChecked, setTogglingChecked] = useState(false)

  async function handleToggleChecked(checked) {
    setTogglingChecked(true)

    return handleUpdateChecklistItem(checklistId, checklistItem.id, {
      checked,
    })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setTogglingChecked(false)
      })
  }

  function handleStartEdit() {
    if (canEdit) {
      setEditing(true)
    }
  }

  function handleCancelEdit() {
    setEditing(false)
  }

  async function handleSubmitEdit(text) {
    setSubmitting(true)

    return handleUpdateChecklistItem(checklistId, checklistItem.id, { text })
      .then(() => {
        setEditing(false)
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  async function handleDelete() {
    return handleDeleteChecklistItem(checklistId, checklistItem.id)
      .then(() => {
        handleAddSuccessNotification(
          REQUEST_PROFILE_TAB_INTERNAL_TASKS_NOTIFICATION_TITLE_KEY.taskDeleted
        )
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  return {
    handleCancelEdit,
    handleDelete,
    handleStartEdit,
    handleSubmitEdit,
    handleToggleChecked,
    isEditing,
    isSubmitting,
    isTogglingChecked,
  }
}
